import { Component, Input } from '@angular/core';
import { Agreement } from '../../models/api/core/agreements/agreement';

@Component({
  selector: 'app-agreement',
  template: `
    @for (item of agreement; track $index) {
      <p [innerHTML]="item.agreementText" tabindex="0"></p>
      <hr />
      <br />
    }
  `,
  styles: ``,
})
export class AgreementComponent {
  @Input()
  agreement: Agreement[];
}
